import { render, staticRenderFns } from "./details.vue?vue&type=template&id=3b77e768&scoped=true&lang=pug&"
import script from "./details.vue?vue&type=script&setup=true&lang=js&"
export * from "./details.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./details.vue?vue&type=style&index=0&id=3b77e768&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b77e768",
  null
  
)

export default component.exports